import React from "react";
import { landingAssets } from "config/landing";
import { activeTheme } from "config/theme";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const customerName = activeTheme.name;
  const landingLogo = landingAssets.logos.main;
  const logoAlt = landingLogo.alt ?? customerName;

  return (
    <footer className="flex flex-col mt-20 items-center gap-3 bg-gray-900 p-5 lg:px-5 lg:py-8 text-xs text-white/60 md:flex-row md:justify-between md:px-10 2xl:px-24">
      <img
        src={landingLogo.src}
        alt={logoAlt}
        className="h-10 w-32 lg:h-14 lg:w-44"
        loading="lazy"
      />
      <p>© {currentYear} {customerName}. All rights reserved.</p>
    </footer>
  );
};
